export enum Sound {
	Stress = 0
}